export default "__VITE_ASSET__DDsLeQfh__"